export default function reducer(state = {
    duration: 0,
    categories: [],
    strCounts: [],
    max_cost: null,
    tours: [],
    update: false,
    toursArray: false
}, action) {
    switch (action.type) {
        case "STORE_ROUND_TOUR_FILTERS": {
            return {
                ...state,
                duration: action.list.max_day,
                categories: action.list.categories,
                strCounts: action.list.str_counts,
                max_cost: action.list.max_cost,
                update: true
            }
        }
        case "STORE_ROUND_TOUR_DETAILS_UPDATE": {
            return {
                ...state,
                update: action.bool
            }
        }
        case "STORE_ROUND_TOUR_LISTS": {
            return {
                ...state,
                tours: action.list.tours
            }
        }
        case "CLEAR_ROUND_TOUR_LISTS": {
            return {
                ...state,
                tours: []
            }
        }
        case "UPDATE_ROUND_TOUR_LIST_ARRAY": {
            return {
                ...state,
                toursArray: action.bool
            }
        }
        case "UPDATE_ROUND_MORE_TOUR_LISTS": {
            return {
                ...state,
                tours: [
                    ...state.tours,
                    ...action.list.tours
                ]
            }
        }
        default:
            break;
    }
    return state
}